
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Categoria } from '@/__env/lib/Web/Categorias';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtrados() { return this.Controlador.Filtrados; }

        public Nueva: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public async Guardar()
        {
            if ( this.Nueva && this.Nueva.length >= 3 )
            {


                let cc = new Categoria();
                cc.Id = 0;
                cc.Descripcion = this.Nueva;
                if ( this.Controlador.Seleccionado && this.Controlador.Seleccionado.Existe )
                {
                    cc.Padre = this.Controlador.Seleccionado;
                }

                if ( await cc.save() )
                {
                    Utiles.Notificaciones.Completado( 'Guardado!' );
                    this.Nueva = '';
                    this.Buscador.Items.unshift( cc );
                }
                else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }



            }
        }

    }
